import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import TextField from '../../../../../../../../../../component/TextField';
import ModalChonKetQuaDichVu from '../../../../../../../../../../phan-he-kham-benh/components/tab-kham-benh/modal-chon-ket-qua-dich-vu/ModalChonKetQuaDichVu';
import { KetQuaDichVu } from '../../../../../../../../../../phan-he-kham-benh/models/ThongTinKhamBenhModel';
import { usePhanHeDieuTriNoiTruContext } from '../../../../../../../../../PhanHeDieuTriContext';
import { useFormikContext } from 'formik';

const TomTatKetQuaCanLamSang = ({ isDialog }: any) => {
	const { benhNhanDieuTri } = usePhanHeDieuTriNoiTruContext();
	const { values, setFieldValue } = useFormikContext<any>();
	const [openModalChonKetQuaDichVu, setOpenModalChonKetQuaDichVu] = useState<boolean>(false);
	const [ketQuaCLS, setKetQuaCLS] = useState<KetQuaDichVu[]>([]);

	useEffect(() => {
		setFieldValue("phieuDieuTri", {
			...values?.phieuDieuTri,
			paraclinicalSummary: ketQuaCLS
				.map(
					item =>
						`${item.tenDichVu} ${item.ketQua !== null ? '(' + item.ketQua + ')' : ''}`
				)
				.join(', '),
		});
	}, [ketQuaCLS]);

	return (
		<div>
			<Button className="link-info bg-white text-decoration-underline spaces pr-0 d-flex ms-auto"
				onClick={() => {
					setOpenModalChonKetQuaDichVu(true);
				}}
			>
				Kết quả cận lâm sàng
			</Button>
			<TextField
				name="paraclinicalSummary"
				value={values?.phieuDieuTri?.paraclinicalSummary ?? ""}
				as="textarea"
				rows={3}
				className={`spaces resize-none ${isDialog ? 'h-667' : 'min-h-60'}`}
			/>
			{openModalChonKetQuaDichVu && (
				<ModalChonKetQuaDichVu
					open={openModalChonKetQuaDichVu}
					handleClose={() => setOpenModalChonKetQuaDichVu(false)}
					onSave={(selectedData: KetQuaDichVu[]) => setKetQuaCLS(selectedData)}
					visitId={benhNhanDieuTri?.visitId}
				/>
			)}
		</div>
	);
};

export default TomTatKetQuaCanLamSang;
